import { render, staticRenderFns } from "./ServiceListManagement.vue?vue&type=template&id=91400d24&"
import script from "./ServiceListManagement.vue?vue&type=script&lang=js&"
export * from "./ServiceListManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports